import { get } from 'lodash';

export const getMainNotificationVisibility = (state) => get(state, 'ui.notifications.main.visible');
